module.exports = __webpack_public_path__ + "static/media/9_Tomas_M@3x.fbbe24e9.jpg";